module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editAnnotationDialog.editAnnotationTitle":"Edit Annotation","editAnnotationDialog.editAnnotationSubtitle":"Edit annotation for this service.","editAnnotationDialog.successfulEdit":"Annotation successfully updated."}}')
  delete Component.options._Ctor
}
